import styled from 'styled-components';

export const FaqMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        border-radius: 1rem;
        box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l15};
        @media (max-width: 768px) {
            margin-top: ${props.theme.spacing.large.l20}
        }
    `
);

export const FaqHeadingText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font20};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const FaqOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: ${props.theme.spacing.base};
    `
);

export const FaqInnerWrapList = styled.ul(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
        list-style-type: none;

        li{
            width:100%;
            display: flex;
            flex-direction: column;
            padding: ${props.theme.spacing.large.l20} 0;
            border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
            cursor: pointer;

            &:last-of-type{
                border-bottom: none;
            }
        }
    `
);

export const FaqHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    `
);

export const FaqHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const FaqDetailWrap = styled.div(
  props => `
    padding-top: ${props.theme.spacing.base};
    display: ${props.active ? 'flex' : 'none'};
  `
);

export const FaqDetailText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
    `
)